export default __webpack_public_path__ + "static/media/Durham-University-Master-Logo_White.61c46d1f.png";